import { SmoothScroll } from "../components/site/SmoothScroll";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Love, Work } from "../components/site/Services";
import { Trust } from "../components/site/Trust";
import { Voyance } from "../components/site/Voyance";
import { Football } from "../components/site/Football";
import { PrivateWork } from "../components/site/PrivateWork";
import { Politicians } from "../components/site/Politicians";
import { Offerings } from "../components/site/Offerings";
import { Testimonials } from "../components/site/Testimonials";
import { Gallery } from "../components/site/Gallery";
import { Share, Footer } from "../components/site/Share";
import { ChatWidget } from "../components/site/ChatWidget";
import { AdminChip } from "../components/site/AdminChip";

export default function Home() {
  return (
    <SmoothScroll>
      <div className="grain relative overflow-x-clip bg-[#0a0908]" data-testid="home-page">
        <Nav />
        <Hero />
        <Marquee />
        <Love />
        <Work />
        <Trust />
        <Voyance />
        <Football />
        <PrivateWork />
        <Politicians />
        <Offerings />
        <Testimonials />
        <Gallery />
        <Share />
        <Footer />
      </div>
      <ChatWidget />
      <AdminChip />
    </SmoothScroll>
  );
}
